import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CacheService } from 'projects/common/src/app/services';
import { CommunicationService } from 'src/app/services/communication';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IOutputFilter } from '../../core/interfaces/output-filter';
import { UrlBuilderService } from 'projects/communication/src/app/services/url-builder.service';

@Injectable({
  providedIn: 'root',
})
export class ReportVitalSignsHourmeterService {
  private baseUrl: string;
  constructor(
    private http: HttpClient,
    private communicationService: CommunicationService,
    private cacheService: CacheService,
    private urlBuilder: UrlBuilderService,
  ) {
    this.baseUrl = this.urlBuilder.serverBasePath;
  }

  /**
   * Function to GetVitalSignHourmeter
   */
  public GetVitalSignHourmeter(selectedFilters: IOutputFilter): Promise<any> {
    const params = this.setParams(selectedFilters);
    const url = `${this.baseUrl}/Report/GetVitalSignHourmeterReport`;
    return this.communicationService.get(url, params).toPromise();
  }

  /** Get report for excel file */
  public GetVitalSignHourmeterExcel(selectedFilters: IOutputFilter): Observable<any> {
    const params = this.setParams(selectedFilters);
    const url = `${this.urlBuilder.apiUrl}/Report/GetVitalSignHourmeterReportDocument`;
    return this.http.get(url, { params, responseType: 'blob' }).pipe(catchError((error) => throwError(() => error.error)));
  }

  /**
   * Function to set params and send selected filters to request
   *
   * @param selectedFilters Filters selected to save params
   */
  public setParams(selectedFilters: IOutputFilter): any {
    return {
      startDate: selectedFilters.startDate,
      endDate: selectedFilters.endDate,
      shiftId: selectedFilters.shiftId,
      machineTypeId: selectedFilters.machineTypeId,
      machineList: selectedFilters.machineId,
      companyId: this.cacheService.local('session').user.company.id,
    };
  }
}
